import React, { Component } from 'react';
import Carousel from 'react-bootstrap/Carousel';

//Images
import Tree1 from '../../../assets/img/services/tree_1.JPG';
import Tree3 from '../../../assets/img/services/tree_3.jpg';

import './controlled-carousel.scss';

class ControlledCarousel extends Component {
    constructor(props, context) {
        super(props, context);
  
        this.handleSelect = this.handleSelect.bind(this);

        const mainImages = [
            { id: 1, src: Tree1, title: "ABC Tree Services", subtitle: "Call US" },
            { id: 2, src: Tree3, title: "ABC Tree Services", subtitle: "Call US" }
        ];
  
        this.state = {
            index: 0,
            direction: null,
            images: mainImages
        };

        
    }
  
    handleSelect(selectedIndex, e) {
        this.setState({
            index: selectedIndex,
            direction: e.direction,
        });
    }
  
    render() {
        const { index, direction } = this.state;
  
      return (
        <Carousel
            activeIndex={index}
            direction={direction}
            onSelect={this.handleSelect}>
            {
                this.state.images.map((item) => 
                    <Carousel.Item key={item.id}>
                        <img
                            height="500"
                            className="d-block w-100"
                            src={item.src}
                            alt={item.alt}
                         />
                        <Carousel.Caption>
                            <h3>{item.title}</h3>
                            <p>{item.subtitle}</p>
                        </Carousel.Caption>
                    </Carousel.Item>
                )
            }
        </Carousel>
      );
    }
}

export default ControlledCarousel;